import { clsx } from 'clsx';
import type { ReactNode } from 'react';
import styles from './ui.module.css';

/**
 * Состояние вещи значком, а не предложением.
 *
 * Раньше статус был строкой текста под карточкой и занимал целую строку у
 * каждой из трёх сущностей имущества. Значок читается боковым зрением и
 * встаёт в один ряд с названием.
 *
 * `solid` — залитая плашка вместо контурной. Нужна ровно там, где значок
 * лежит ПОВЕРХ фотографии: контур на пёстром кадре не читается, а на светлых
 * местах пропадает совсем. В макетах так набрано общежитие на портрете.
 */

export type StatusTone = 'published' | 'pending' | 'rejected' | 'archived' | 'warning';

const TONE: Record<StatusTone, string> = {
  published: styles.badgePublished,
  pending: styles.badgePending,
  rejected: styles.badgeRejected,
  archived: styles.badgeArchived,
  warning: styles.badgeWarning,
};

export function StatusBadge({
  tone,
  solid = false,
  size = 'm',
  children,
}: {
  tone: StatusTone;
  solid?: boolean;
  size?: 'm' | 'l';
  children: ReactNode;
}) {
  return (
    <span
      className={clsx(
        styles.badge,
        solid ? SOLID[tone] : TONE[tone],
        size === 'l' && styles.badgeLarge,
      )}
    >
      {children}
    </span>
  );
}

const SOLID: Record<StatusTone, string> = {
  published: styles.badgeSolidPublished,
  pending: styles.badgeSolidPending,
  rejected: styles.badgeSolidRejected,
  archived: styles.badgeSolidArchived,
  warning: styles.badgeSolidPending,
};
